export interface Overlays {
  tasks: boolean
  completed: boolean
  weather: boolean
}

interface OverlayTogglesProps {
  overlays: Overlays
  onToggle: (key: keyof Overlays) => void
}

const CONFIG: { key: keyof Overlays; label: string; dot: string; activeBg: string; activeText: string }[] = [
  { key: 'tasks', label: 'Zadania', dot: 'bg-botanical', activeBg: 'bg-botanical-light', activeText: 'text-botanical' },
  { key: 'completed', label: 'Wykonane', dot: 'bg-gold', activeBg: 'bg-gold/15', activeText: 'text-gold' },
  { key: 'weather', label: 'Pogoda', dot: 'bg-water', activeBg: 'bg-water/15', activeText: 'text-water' },
]

export function OverlayToggles({ overlays, onToggle }: OverlayTogglesProps) {
  return (
    <div className="flex items-center gap-xs">
      {CONFIG.map(({ key, label, dot, activeBg, activeText }) => {
        const active = overlays[key]
        return (
          <button
            key={key}
            onClick={() => onToggle(key)}
            className={`flex items-center gap-xs px-sm py-xs rounded-full font-label text-xs tracking-wide border transition-colors ${
              active
                ? `${activeBg} ${activeText} border-current`
                : 'bg-paper-dark text-frame/50 border-frame/20'
            }`}
          >
            <span className={`inline-block w-2 h-2 rounded-full ${active ? dot : 'bg-frame/30'}`} />
            {label}
          </button>
        )
      })}
    </div>
  )
}
